import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'sym-incentive-menu-item',
  templateUrl: './menu-incentive-item.component.html',
  styleUrls: ['./menu-incentive-item.component.css'],
})
export class MenuIncentiveItemComponent {
  @Input() node: any;
  @Input() expandedNodes: { [key: number]: any };
  @Input() activeNode: any;
  @Output() nodeClicked = new EventEmitter<any>();

  get expanded(): boolean {
    // Check if the current node is expanded
    const nodeKey = `${this.node.level}-${this.node.evaluationdtlId}`;
    return this.expandedNodes?.[nodeKey] === this.node;
  }
  get isActive(): boolean {
    // Check if the current node is the active one
    return this.activeNode?.evaluationdtlId === this.node.evaluationdtlId;
  }
  constructor() {
    // this.expanded = false;
  }
  ngOnInit() {}
  onNodeClick() {
    this.nodeClicked.emit(this.node);
  }
}
